import { render } from "./BookingVillaOwner.vue?vue&type=template&id=5885be06"
import script from "./BookingVillaOwner.vue?vue&type=script&lang=js"
export * from "./BookingVillaOwner.vue?vue&type=script&lang=js"

import "./BookingVillaOwner.vue?vue&type=style&index=0&id=5885be06&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__